import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseMaterialTypeForm from '../../../components/forms/CourseMaterialTypeForm';
import { useCourseMaterialTypeApi } from '../../../hooks/useCourseMaterialTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CourseMaterialTypeDTO } from '../../../services/apiClient';

const CourseMaterialTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCourseMaterialTypeApi();
  const [entityData, setEntityData] = useState<CourseMaterialTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Course Material Types', href: '/admin/coursematerialtypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CourseMaterialType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/coursematerialtypes');
    } catch (error) {
      console.error('Error updating CourseMaterialType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/coursematerialtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CourseMaterialType.Edit'
    >
        {entityData ? (
          <CourseMaterialTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/coursematerialtypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CourseMaterialTypeEdit;